
import React, { useEffect, useState } from "react";
import app from "../components/app";

const saveFooter = function() {
  app.fetchPost({
      method:"saveFooter",
      appId:document.querySelector("#appId").value, 
      userId:"123456",
      footerJson:JSON.stringify(JSON.parse(document.querySelector("#footerJson").value)),
  }, true).then(function(response){
      console.log(response);
      //callback(response); 
  })
}

const SaveHeaderFooter = function(){
  return <div className="w-100 h-100 p-4 footerJsonSave">
    <style>
      {`
      .footerJsonSave h1,
      .footerJsonSave input,
      .footerJsonSave .button {
        height:50px;
        margin:0 0 10px 0;
      }
      .footerJsonSave .button {
        margin:0
      }
      .footerJsonSave textarea{
        height:calc(100% - 180px);
        margin:0 0 10px 0;
      }
      `}
    </style>
    <h1 style={{height:"50px"}} className="mb-3">Footer</h1>
    <input type="text" id="appId" placeholder="appId" className="form-control mb-3" />
    <textarea id="footerJson" placeholder="footerJson" className="form-control"></textarea>
    <div className="w-100 text-right button"><button type="button" className="btn btn-success" onClick={saveFooter}>Save</button></div>
  </div>
}


export default SaveHeaderFooter;


